import moment from 'moment';

import BaseStore from 'src/storage/base';

class Schedule2Model extends BaseStore {
  id = 'schedule2';
  defaultState = () => ({
    editingSlots: [],
    weekSlots: [],
    selectedDate: null,
    selectedSlot: null
  });
  apiConfig = {
    list: {
      url: 'schedule/list',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount',
    reload_schedule: 'reloadSchedule'
  };

  reloadSchedule = () => {
    if (this.state.selectedDate) this.selectDay(this.state.selectedDate, true);
  };

  filterByDateHour = (date, hour) => {
    return this.state.weekSlots
      .filter(
        (item) =>
          item.slotDate === date.format('YYYYMMDD') &&
          moment(item.startDate).format('HH') === hour.toString()
      )
      .sort((a, b) => a.startDate - b.startDate);
  };

  selectDay = (day, reset = false) => {
    let prevDay = this.state.selectedDate;
    const startOfWeek = day.clone().startOf('isoWeek');
    const endOfWeek = day.clone().endOf('isoWeek');

    const previousError = this.getApiState('list').error;

    // dont reload if same week
    if (
      !previousError &&
      !reset &&
      prevDay &&
      prevDay.clone().startOf('isoWeek').isSame(startOfWeek, 'day')
    ) {
      this.setState({ selectedDate: day });
    } else {
      if (!this.state.user?.isDoctor && !this.state.doctor)
        return this.setState({ selectedDate: day, weekSlots: [] });
      this.setState({ selectedDate: day });
      this.api(
        'list',
        {
          from: startOfWeek.valueOf(),
          to: endOfWeek.valueOf(),
          id: this.state.doctor?.id
        },
        (err, res, success) => {
          if (success)
            this.setState({
              weekSlots: res.map((slot) => {
                slot.slotDate = moment(slot.startDate).format('YYYYMMDD');
                if (!slot.patientId) slot.patientId = 0;
                return slot;
              })
            });
        }
      );
    }
  };
}

const model = new Schedule2Model();
export default model;
